import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * Kbd · representación visual de una tecla del teclado (⌘, K, ↵, esc, etc).
 * Usado en command palette, sidebar shortcuts, tweaks panel.
 *
 * Estilo definido en `.kbd` dentro de `src/index.css` (auto dual theme).
 */
interface KbdProps {
  children: ReactNode;
  className?: string;
}

export function Kbd({ children, className }: KbdProps) {
  return <span className={cn('kbd', className)}>{children}</span>;
}
